module.exports = __webpack_public_path__ + "static/media/instagram.94f4abab.png";